// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_Button__OkDLc {
  border: none;
  padding: 1rem 2rem;
  border-radius: 5rem;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  background-color: transparent;
}

.styles_Button__OkDLc:active {
  transform: translateY(0.1rem);
  transition: transform 0.01s ease;
}

.styles_Button__OkDLc:hover img {
  opacity: 1!important;
  left: 50%!important;
}

.styles_contactUsButton__HZ7fx {
  outline: none;
  border-radius: 4rem;
  font-weight: bold;

  display: flex;

  color: var(--text-color0);
  background: linear-gradient(90deg, rgba(255, 105, 51, 0.2) 0%, rgba(9,9,121,0) 33%, #e86f43 67%, #ff4500 100%);
  background-size: 400%, 400%;
  padding: 0.8rem 1.4rem;
  /* border: 0.14rem solid red; */
  box-shadow: 0 0.2rem transparent;
  text-decoration: none!important;
  transition: background 800ms 1s ease, color 800ms 1s ease;
}

.styles_contactUsButton__HZ7fx:hover, .styles_contactUsButton__HZ7fx:focus {
  color: white;
  background-position: 97% 0%;
  transition: background 800ms ease, color 500ms ease;
}

/* .contactUsButton:hover::after,
.contactUsButton:focus::after {
	opacity: 0;
} */
`, "",{"version":3,"sources":["webpack://./src/pages/public/Home/styles.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;;EAEjB,aAAa;;EAEb,yBAAyB;EACzB,8GAA8G;EAC9G,2BAA2B;EAC3B,sBAAsB;EACtB,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;EAC/B,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;;;GAGG","sourcesContent":[".Button {\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 5rem;\n  color: white;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  background-color: transparent;\n}\n\n.Button:active {\n  transform: translateY(0.1rem);\n  transition: transform 0.01s ease;\n}\n\n.Button:hover img {\n  opacity: 1!important;\n  left: 50%!important;\n}\n\n.contactUsButton {\n  outline: none;\n  border-radius: 4rem;\n  font-weight: bold;\n\n  display: flex;\n\n  color: var(--text-color0);\n  background: linear-gradient(90deg, rgba(255, 105, 51, 0.2) 0%, rgba(9,9,121,0) 33%, #e86f43 67%, #ff4500 100%);\n  background-size: 400%, 400%;\n  padding: 0.8rem 1.4rem;\n  /* border: 0.14rem solid red; */\n  box-shadow: 0 0.2rem transparent;\n  text-decoration: none!important;\n  transition: background 800ms 1s ease, color 800ms 1s ease;\n}\n\n.contactUsButton:hover, .contactUsButton:focus {\n  color: white;\n  background-position: 97% 0%;\n  transition: background 800ms ease, color 500ms ease;\n}\n\n/* .contactUsButton:hover::after,\n.contactUsButton:focus::after {\n\topacity: 0;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Button": `styles_Button__OkDLc`,
	"contactUsButton": `styles_contactUsButton__HZ7fx`
};
export default ___CSS_LOADER_EXPORT___;
